import { OwcCheckbox } from '@one/react';
import styles from './OrphanAck.module.css';

export default function OrphanAck({ count = 0, checked, onChange }) {
  if (count <= 0) return null;
  const one = count === 1;
  return (
    <div className={styles.wrapper}>
      <OwcCheckbox checked={checked} onValueChange={(e) => onChange?.(e.detail)}>
        <span className={styles.label}>
          I understand that <strong>{count}</strong> entit{one ? 'y' : 'ies'} will lose{' '}
          {one ? 'its' : 'their'} <strong>Latest</strong> version with no replacement (orphan risk).
        </span>
      </OwcCheckbox>
    </div>
  );
}
